module.exports = __webpack_public_path__ + "static/media/RoundCard.02c0e47f.png";